import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f139c34c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "log"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/record"
}, "开奖记录")], -1));
const _hoisted_2 = {
  class: "prize"
};
const _hoisted_3 = {
  class: "cont"
};
const _hoisted_4 = {
  class: "gallery-imgs"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_7 = {
  class: "dmbp_other"
};
import nav_header from '@/components/nav_header.vue';
import swipers from '@/components/swipers.vue';
import yearsVue from '@/components/years.vue';
import comment from '@/components/comment.vue';
import otherTail from '@/components/otherTail.vue';
import priz_result from '@/components/priz_result.vue';
import { cancel_follow, article_like, comment_list, comment_add, tukuDetail, article_coll, article_index } from '@/util/http.js';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import axios from "axios"; //原生的axios 

import { showImagePreview } from 'vant';
import { ref } from 'vue';

import { reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'galleryDesc',
  setup(__props) {
    let showss = ref(false);
    let dmbpOther = reactive([{
      name: '评论',
      num: '0',
      src: require('@/assets/image/commont.png')
    }, {
      name: '赞',
      num: '0',
      src: require('@/assets/image/zan.png')
    }, {
      name: '收藏',
      num: '0',
      src: require('@/assets/image/wujiaoxin.png')
    }, {
      name: '分享',
      num: '',
      src: require('@/assets/image/fenxiang.png')
    }, {
      name: ' ',
      num: '0',
      src: require('@/assets/image/look.png')
    }]);
    const route = useRoute();
    let objlist = ref({});
    let tid = ref('');
    let qis = ref('');
    let record = ref('');
    onMounted(() => {
      let id = route.params.id;
      let qi = route.params.qi;
      qis.value = qi;
      tid.value = id;
      gallery(id, '', qi);
      commentCont(id);
      record.value = qi;
      // tuku_Detail(id)
    });

    let years = ref('');
    let yearFu = data => {
      years.value = data;
      gallery(tid.value, data, '', '');
    };
    let qishuFun = data => {
      record.value = data;
      qis.value = data;
      gallery(tid.value, years.value, data, '1');
    };
    let issue_list = ref();
    // let gallery = (id,year,issue)=>{
    //     let url = `https://jl.tukuapi.com/api/tuku_detail?id=${id}&year=${year}&issue=${issue}`
    //     axios.get(url).then(res=>{
    //         let data = res.data.data;
    //         // data.issue_year.push(data.issue_year[0]-1,data.issue_year[0]-2,data.issue_year[0]-3,);
    //         // years.value = data.issue_year[0];

    //     })
    // }
    let gallery = (id, year, issue, d = '') => {
      tukuDetail({
        id: id,
        year: year,
        issue: issue
      }).then(res => {
        let data = res.data;
        dmbpOther[1].num = data.good_count;
        dmbpOther[4].num = data.browse.num;
        dmbpOther[2].num = data.store_count;
        // dmbpOther[2].num = data.fans_count
        if (data.is_like) {
          dmbpOther[1].src = require('@/assets/image/on_zan.png');
        } else {
          dmbpOther[1].src = require('@/assets/image/zan.png');
        }
        if (data.is_store) {
          dmbpOther[2].src = require('@/assets/image/heiwijioaxin.png');
        } else {
          dmbpOther[2].src = require('@/assets/image/wujiaoxin.png');
        }
        issue_list.value = data.issue_list;
        objlist.value = data;
        if (d == '') {
          record.value = data.issue_list[0];
        }
      });
    };

    // let articleIndex = (id,pages,content='')=>{
    //         article_index({type_id:3,page:pages,search:content}).then(res=>{
    //         let data = res.data.data;
    //         if(data.length == '0'){
    //             finished.value = true;
    //         }else{
    //             loading.value = false;
    //             formulaArray.push(...data)
    //         }     
    //     })
    // }
    let commentList = ref([]);
    const loading = ref(true);
    const finished = ref(false);
    let page = ref(1);
    const onLoad = () => {
      page.value++;
      commentCont(tid.value, page.value);
    };
    let commentCont = (id, page) => {
      //帖子
      comment_list({
        id: id,
        type: 2,
        page: page
      }).then(res => {
        dmbpOther[0].num = res.data.total;
        let datas = res.data.data;
        if (datas.length == 0) {
          finished.value = true;
        } else {
          loading.value = false;
          commentList.value.push(...datas);
        }
      });
    };
    let commentadd = (content, uid, id, url) => {
      //帖子
      comment_add({
        content: content,
        type: 2,
        level_uid: uid,
        level_id: id
      }, url).then(res => {
        if (res.code == '320') {
          showss.value = true;
          return false;
        }
        showToast(res.message);
        commentCont(tid.value);
        loading.value = false;
        activeIndexs.value = false;
      });
    };
    let activeIndexs = ref(false);
    let onSubmitFun = e => {
      //帖子

      commentadd(e.content, e.level_uid, e.level_id, tid.value);
    };
    let returnUp = () => {
      activeIndexs.value = false;
    };
    let opencomment = () => {
      activeIndexs.value = true;
    };
    let commentNext = () => {
      activeIndexs.value = true;
    };
    let infoFn = data => {
      if (data.name == '收藏') {
        article_coll({
          type: 2
        }, tid.value).then(res => {
          if (res.code == '320') {
            showss.value = true;
            return false;
          }
          if (res.code != "400") {
            dmbpOther[2].num = dmbpOther[2].num + 1;
          }
          dmbpOther[2].src = require('@/assets/image/heiwijioaxin.png');
          showToast(res.message);
        });
      } else if (data.name == '赞') {
        article_like({
          type: 2,
          state: 2
        }, tid.value).then(res => {
          if (res.code == '320') {
            showss.value = true;
            return false;
          }
          showToast(res.message);
          if (res.message != "您已赞过") {
            dmbpOther[1].num = dmbpOther[1].num + 1;
          }
          dmbpOther[1].src = require('@/assets/image/on_zan.png');
        });
      } else if (data.name == '分享') {
        copy();
      }
    };
    let copy = () => {
      let r = window.location.href;
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', r);
      input.setAttribute('readonly', 'readonly');
      input.select();
      input.setSelectionRange(0, 999);
      if (document.execCommand('copy')) {
        showToast("复制成功");
      }
      document.body.removeChild(input);
    };
    let proImage = img => {
      showImagePreview([img]);
    };
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      const _component_logos = _resolveComponent("logos");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "图库详情"
      }, {
        more: _withCtx(() => [_hoisted_1]),
        _: 1
      }), _createVNode(swipers), _createElementVNode("div", _hoisted_2, [_createVNode(priz_result)]), _createVNode(yearsVue, {
        qishuArray: _unref(issue_list),
        issue_year: _unref(objlist).issue_year,
        record: _unref(record),
        onYearFuc: _unref(yearFu),
        onQishuFun: _unref(qishuFun)
      }, null, 8, ["qishuArray", "issue_year", "record", "onYearFuc", "onQishuFun"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(objlist).image_path,
        alt: "",
        onClick: _cache[0] || (_cache[0] = $event => _unref(proImage)(_unref(objlist).image_path))
      }, null, 8, _hoisted_5), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(otherTail, {
        navlist: _unref(dmbpOther),
        onInfoFn: _unref(infoFn)
      }, null, 8, ["navlist", "onInfoFn"])])]), _createVNode(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[1] || (_cache[1] = $event => loading.value = $event),
        finished: finished.value,
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createVNode(comment, {
          onSubmit: _unref(onSubmitFun),
          onReturnUp: _unref(returnUp),
          onOpencomment: _unref(opencomment),
          onCommentNext: _unref(commentNext),
          commentList: _unref(commentList),
          activeIndexs: _unref(activeIndexs)
        }, null, 8, ["onSubmit", "onReturnUp", "onOpencomment", "onCommentNext", "commentList", "activeIndexs"])]),
        _: 1
      }, 8, ["loading", "finished"]), _createVNode(_component_logos, {
        shows: _unref(showss),
        "onUpdate:shows": _cache[2] || (_cache[2] = $event => _isRef(showss) ? showss.value = $event : showss = $event)
      }, null, 8, ["shows"])], 64);
    };
  }
};